var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-progress-bar",style:({ height: `${_vm.height}px`, borderRadius: `${_vm.height / 2}px` })},[_c('div',{staticClass:"custom-progress-bar__track"}),_vm._v(" "),_c('div',{staticClass:"custom-progress-bar__fill",style:(_vm.fillStyle)}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }